import React, { useCallback, useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import UIEventBus from '../EventBus';

const HELP_TEXT = 'Click anywhere to begin';

type HelpPromptProps = {};

const HelpPrompt: React.FC<HelpPromptProps> = () => {
    const [helpText, setHelpText] = useState('');
    const [visible, setVisible] = useState(true);
    const visRef = useRef(visible);

    const typeHelpText = (i: number, curText: string) => {
        if (i < HELP_TEXT.length && visRef.current) {
            setTimeout(() => {
                window.postMessage({ type: 'keydown', key: `_AUTO_${HELP_TEXT[i]}` }, '*');
                setHelpText(curText + HELP_TEXT[i]);
                typeHelpText(i + 1, curText + HELP_TEXT[i]);
            }, Math.random() * 120 + 50);
        }
    };

    useEffect(() => {
        setTimeout(() => {
            typeHelpText(0, '');
        }, 500);
        document.addEventListener('mousedown', () => {
            setVisible(false);
        });
        UIEventBus.on('enterMonitor', () => {
            setVisible(false);
        });
    }, []);

    useEffect(() => {
        if (visible === false) {
            window.postMessage({ type: 'keydown', key: `_AUTO_` }, '*');
        }
        visRef.current = visible;
    }, [visible]);

    return helpText.length > 0 ? (
        <motion.div
            variants={vars}
            animate={visible ? 'visible' : 'hide'}
            style={styles.container}
            className="macos-toast"
        >
            <span style={styles.dot} />
            <p style={styles.text}>{helpText}</p>
        </motion.div>
    ) : (
        <></>
    );
};

const vars = {
    visible: { opacity: 1, y: 0 },
    hide: {
        y: 12,
        opacity: 0,
        transition: { duration: 0.4, ease: 'easeOut' },
    },
};

const styles: { [key: string]: React.CSSProperties } = {
    container: {
        position: 'absolute',
        bottom: 64,
    },
    dot: {
        width: 6,
        height: 6,
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.5)',
        flexShrink: 0,
    },
    text: {
        fontSize: 13,
        fontWeight: 400,
        color: 'rgba(255,255,255,0.85)',
        letterSpacing: 0.1,
    },
};

export default HelpPrompt;
